var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.9808L1.832 3.928C1.68242 3.78118 1.4812 3.69892 1.2716 3.69892C1.062 3.69892 0.860779 3.78118 0.7112 3.928L0.508 4.128C0.432169 4.20247 0.371936 4.2913 0.330818 4.3893C0.289701 4.48731 0.268524 4.59252 0.268524 4.6988C0.268524 4.80508 0.289701 4.9103 0.330818 5.0083C0.371936 5.10631 0.432169 5.19514 0.508 5.2696L7.44 12.072C7.58924 12.2192 7.79041 12.3017 8 12.3017C8.20959 12.3017 8.41076 12.2192 8.56 12.072L15.492 5.2696C15.568 5.19512 15.6283 5.10624 15.6695 5.00817C15.7107 4.91009 15.7319 4.80478 15.7319 4.6984C15.7319 4.59203 15.7107 4.48672 15.6695 4.38864C15.6283 4.29056 15.568 4.20168 15.492 4.1272L15.2888 3.9272C15.1393 3.78062 14.9382 3.69852 14.7288 3.69852C14.5194 3.69852 14.3183 3.78062 14.1688 3.9272L8 9.9816V9.9808Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.c4b513210e205c057fe9eba69868d7be.svg";
export { ForwardRef as ReactComponent };